/*global _ */
import {fv} from '../../lib/utils'
import {optionsHydrator} from '../../lib/form/input'

import props from '../../props/inputs'
import optionsProps from '../../props/inputs-options'

import InputMixin from '../../mixins/form/input'
const mixins = [InputMixin]

export const OPTIONS_PROP = 'advancedSettings'

export default {
  mixins,
  props: {
    ...props,
    ...optionsProps,
    name: {
      type: String,
      require: false,
    },
    inputComponent: {},
    inputComponentAttrs: {},
    inputSelectedComponentAttrs: {},
    itemsContainerClass: {}
  },
  data() {
    return {
      innerOptions: this.options,
      optionsPropName: OPTIONS_PROP,
    }
  },
  computed: {
    optionsList() {
      // [1,2,3]
      //[{value, label}, {}, {}]
      //{value: label, value2: label2}
      let source = this.innerOptions
      if (_.isString(source)) {
        source = [source]
      }
      const sourceIsArray = _.isArray(source)
      const itemIsObject = sourceIsArray && _.isPlainObject(_.first(source))

      const useArrayOptions = this.useArrayOptions
      if (sourceIsArray && !useArrayOptions && !itemIsObject) {
        source = _.mapKeys(source)
      }
      const reducer = this.reduceOptions
      if (reducer) {
        if (reducer) {
          if (_.isFunction(reducer)) {
            return reducer.call(this, source)
          } else {
            return this.parseReactiveValues(reducer, source)
          }
        }
      }

      const internalReducer = this.internalReduceOptions
      if (internalReducer) {
        return internalReducer(source)
      }

      return _.reduce(source, (o, i, k) => {
        const itemIsObject = _.isObject(i)
        let item = itemIsObject ? i : {label: i, value: k}
        const label = this.getOptionLabel(item, k, source)
        const value = this.getOptionValue(item, k, source)
        let data = {...item, label, value}
        if (_.isFunction(this.reduceOptionItem)) {
          data = this.reduceOptionItem(data, item, k, source)
        }
        o.push(data)
        return o
      }, [])
    },
    hasBlankOption() {
      return this.blankOption !== false && !_.isNil(this.blankOption)
    },
    modelLabel() {
      return (_.find(this.optionsList, o => o.value === this.model) || {}).label
    }
  },
  watch: {
    options: {
      handler(newValue) {
        this.innerOptions = newValue
      },
      deep: true
    }
  },
  methods: {
    getOptionValue(option, index, options) {
      option = fv(option, options[index])
      const reducer = this.reduceValue
      if (_.isFunction(reducer)) {
        return reducer.call(this, option, index, options)
      }
      if (reducer) {
        return this.parseReactiveValues(reducer, option)
      }
      const {value, id, name, label, title, text} = option || {}
      return fv(value, id, name, label, title, text)
    },
    getOptionAttrs(option, index, options) {
      option = fv(option, options[index])
      return option.attrs || {}
    },
    getOptionLabel(option, index, options) {
      option = fv(option, options[index])
      const reducer = this.reduceLabel
      if (_.isFunction(reducer)) {
        return reducer.call(this, option, index, options)
      }
      if (reducer) {
        return this.parseReactiveValues(reducer, option)
      }
      const {value, id, name, label, title, text} = option || {}
      return fv(title, label, text, name, value, id)
    },
    hydrator: optionsHydrator
  }
}
